import styled from 'styled-components';
import { getTextColor } from '@magalu/stereo-ui-styles';
import { Grid, Text, Button } from '../../atoms';
export const Wrapper = styled(Grid).attrs(props => Object.assign({
  my: 3,
  mx: 2,
  rowGap: 3
}, props))`
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 0.5fr 0.5fr;
  grid-template-areas:
    'input-values input-values'
    'slider-input slider-input'
    'apply-button apply-button';
`;
export const InputValuesWrapper = styled(Grid).attrs(props => Object.assign({
  gap: 2
}, props))`
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  grid-area: input-values;
`;
export const SliderInputWrapper = styled.div`
  z-index: 0;
  grid-area: slider-input;
  position: relative;
`;
export const InputLabel = styled(Text)`
  color: ${props => getTextColor('scratched')(props)};
`;
export const ApplyButton = styled(Button)`
  grid-area: apply-button;
`;